import OrderNoteService from "@/services/orderNote.service.js";
import Auth from "@/services/auth.service";
const authService = new Auth();
// import store from "@/stores/index.js";

export default class OrderNote {
  constructor () {
    this.orderNoteService = new OrderNoteService();
  }

  getOrderNotes (options) {
    return this.orderNoteService.list(options);
  }

  async sendOrderNote (options) {
    try {
      const userId = await authService.getCurrentUserId();
      options.fromUserId = userId;
      const res = await this.orderNoteService.create(options);
      return res;
    } catch (err) {
      console.error(err);
      return false;
    }
  }
}
